// Right-side slide-in drawer for admin pages. Ported from Cambonic_SaaS
// admin/ui/Drawer.tsx — same shell, translated to Tailwind 3 arbitrary
// syntax + the local token bridge (--color-navy, --color-linen).

import { useEffect, type ReactNode } from 'react';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: string;
}

export function Drawer({ open, onClose, children, width = 'w-[480px]' }: DrawerProps) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <>
      <div
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
        className={`fixed inset-0 z-40 bg-[rgb(var(--color-navy)/0.3)] backdrop-blur-[2px] transition-opacity duration-200 ${
          open ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      />
      <aside
        role="dialog"
        aria-modal="true"
        className={`fixed top-0 right-0 z-50 h-screen ${width} max-w-[100vw] bg-[rgb(var(--color-linen))] shadow-2xl border-l border-[rgb(var(--color-navy)/0.1)] transition-transform duration-200 ease-out flex flex-col ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {children}
      </aside>
    </>
  );
}
